import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section id="comprar" className="py-24 bg-gradient-to-br from-brand-blue/40 via-brand-mint/30 to-brand-lilac/40 relative overflow-hidden" data-id="element-1">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-2">
        <div className="absolute top-10 left-10 w-32 h-32 bg-brand-yellow rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob" data-id="element-3"></div>
        <div className="absolute top-10 right-10 w-32 h-32 bg-brand-pink rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-2000" data-id="element-4"></div>
        <div className="absolute -bottom-8 left-20 w-32 h-32 bg-brand-mint rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-4000" data-id="element-5"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/80 backdrop-blur-md p-8 md:p-12 rounded-3xl shadow-xl border border-white" data-id="element-7">
          <div className="inline-flex items-center justify-center p-3 bg-brand-primary/10 rounded-full mb-6" data-id="element-8">
            <Sparkles className="text-brand-primary" size={32} data-id="element-9" />
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold text-brand-dark mb-6" data-id="element-10">
            Comenzá hoy mismo
          </h2>

          <p className="text-xl text-brand-text mb-10 max-w-2xl mx-auto font-medium" data-id="element-11">
            Ayudá a tu hijo a desarrollar habilidades fundamentales mientras
            aprende jugando.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-12">
            <a href="https://checkout.complementodigital.shop/cart/40783303901313:1" target="_blank" rel="noopener noreferrer" className="btn-primary w-full sm:w-auto text-xl px-10 py-5 group relative overflow-hidden" data-id="element-13">
              <span className="relative z-10 flex items-center gap-2" data-id="element-14">
                🔥 SOLO POR HOY $18.990
              </span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-15" />
            </a>

            <p className="text-slate-500 font-semibold line-through" data-id="element-16">
              Precio habitual $49.990
            </p>

            <div className="mt-6 p-4 bg-slate-50 rounded-xl border border-slate-100 max-w-md w-full" data-id="element-17">
              <p className="text-sm font-bold text-brand-dark text-center" data-id="element-18">
                Incluye 5 módulos, 6 bonus, 3 plus y plantillas imprimibles.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}